'use client';

import type { ButtonHTMLAttributes, HTMLAttributes, ReactNode } from 'react';

export function Menu({ children, className, ariaLabel, ...rest }: HTMLAttributes<HTMLDivElement> & { ariaLabel?: string }) {
  return (
    <div className={`mx-menu${className ? ` ${className}` : ''}`} role="menu" aria-label={ariaLabel} {...rest}>
      {children}
    </div>
  );
}

export function MenuLabel({ children }: { children: ReactNode }) {
  return <div className="mx-menu__label">{children}</div>;
}

export function MenuSeparator() {
  return <div className="mx-menu__sep" role="separator" />;
}

export interface MenuItemProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  danger?: boolean;
  icon?: ReactNode;
  /** Untuk role menuitemcheckbox/menuitemradio: tampilkan centang via mx-menu__check. */
  check?: boolean;
}
export function MenuItem({ danger, icon, check, children, className, role = 'menuitem', ...props }: MenuItemProps) {
  const cls = ['mx-menu__item', danger && 'mx-menu__item--danger', check !== undefined && 'mx-menu__item--check', className]
    .filter(Boolean)
    .join(' ');
  return (
    <button type="button" role={role} className={cls} {...props}>
      {icon}
      {children}
      {check !== undefined && (
        <span className="mx-menu__check" aria-hidden="true">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 6 9 17l-5-5" />
          </svg>
        </span>
      )}
    </button>
  );
}
